import { applicationActionTypes } from '../constants/actionTypes';

const defaultState = {
  staticCopy: null,

  isLoadingCustomLogo: true,
  customLogo: null,
  customFavi: null,
  customTitle: null,

  errorBanner: null,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case applicationActionTypes.setCustomClientLogo: {
      if (action.payload === null)
        return {
          ...state,
          isLoadingCustomLogo: false,
        };

      const { logo, favi, title } = action.payload;
      return {
        ...state,
        isLoadingCustomLogo: false,
        customLogo: logo,
        customFavi: favi,
        customTitle: title,
      };
    }
    case applicationActionTypes.setStaticCopy: {
      return {
        ...state,
        staticCopy: action.payload,
      };
    }

    case applicationActionTypes.showErrorBanner: {
      return {
        ...state,
        errorBanner: action.payload,
      };
    }

    case applicationActionTypes.hideErrorBanner: {
      return {
        ...state,
        errorBanner: null,
      };
    }

    default:
      return state;
  }
}
